<template>
  <div id="app-div" style="overflow-y: hidden">
    <div class="top">
      <div class="search_icon">
        <span style="margin-left: 10px">
          <img src="../../../../assets/u3220.png" class="icon_img" />
          筛选查询
        </span>
      </div>
      <div class="query_div">
        <a-row>
          <a-col :span="5">
            <label>用户账号：</label>
            <a-input placeholder="请输入" v-model="queryUserName" class="query_input" />
          </a-col>
          <a-col :span="5">
            <label>用户姓名：</label>
            <a-input placeholder="请输入" v-model="queryName" class="query_input" />
          </a-col>
          <a-col :span="5">
            <label>用户角色：</label>
            <a-select defaultValue="0" class="query_input" v-model="queryRoleCode">
              <a-select-option value="0">全部</a-select-option>
              <a-select-option v-for="item in roles" :value="item.roleCode" :key="item.roleCode">{{
                item.roleName
              }}</a-select-option>
            </a-select>
          </a-col>
          <a-button type="primary" class="query_btn" @click="query"> 查询 </a-button>
          <a-button style="margin-left: 10px" type="primary" @click="() => addMethod('add')"> 新增 </a-button>
        </a-row>
      </div>
    </div>
    <div class="middle">
      <div style="float: left; margin-left: 10px">
        <img src="../../../../assets/u3227.png" class="icon_img" />
        <span>&nbsp;数据列表</span>
      </div>
      <div class="sortType" style="float: right">
        排序方式：
        <a-select size="small" defaultValue="1" style="width: 120px" @change="sortChange" v-model="sort">
          <a-select-option value="1">编号降序</a-select-option>
          <a-select-option value="2">编号升序</a-select-option>
          <a-select-option value="3">时间降序</a-select-option>
          <a-select-option value="4">时间升序</a-select-option>
        </a-select>
      </div>
    </div>
    <div class="bottom" id="bottom">
      <div class="table_box">
        <a-table
          :pagination="false"
          :rowSelection="rowSelection"
          :columns="columns"
          :dataSource="data"
          :rowKey="record => record.userCode"
          size="small"
          :scroll="{ y: data.length < 8 ? false : table_height }"
          bordered
        >
          <span slot="operator" slot-scope="text, record">
            <a href="javascript:void(0);" @click="() => checkMethod(record, 'check')">查看</a>
            <a-divider type="vertical" />
            <a href="javascript:void(0);" @click="() => editMethod(record, 'edit')">编辑</a>
            <a-divider type="vertical" />
            <a href="javascript:void(0);" @click="() => changeStatus(record, 1)">启用</a>
            <a-divider type="vertical" />
            <a href="javascript:void(0);" @click="() => changeStatus(record, 0)">禁用</a>
            <a-divider type="vertical" />
            <a href="javascript:void(0);" @click="() => deleteMethod(record)">删除</a>
            <a-divider type="vertical" />
            <a href="javascript:void(0);" @click="() => updatePwd(record)">重置密码</a>
          </span>
          <span slot="status" slot-scope="text, record">
            <label v-if="record.status == '1'">
              <img class="status_img" src="../../../../assets/open.png" />已启用
            </label>
            <label v-if="record.status == '0'">
              <img class="status_img" src="../../../../assets/close.png" />已禁用
            </label>
          </span>
          <span slot="isEdit" slot-scope="text, record">
            <span v-if="record.roleName.indexOf('责编') != -1">
              <label v-if="record.isEdit == 1">是</label>
              <label v-if="record.isEdit == 0">否</label>
            </span>
            <span v-else>
              <label>--</label>
            </span>
          </span>
        </a-table>
      </div>
      <div id="components-pagination-demo-mini">
        <a-pagination
          :total="total"
          :showTotal="total => `共 ${total} 条`"
          showSizeChanger
          showQuickJumper
          :pageSizeOptions="pageSizeOptions"
          :defaultPageSize="limit"
          @showSizeChange="onShowSizeChange"
          @change="pageChange"
        />
      </div>
      <a-select defaultValue="0" class="batch_operation" @change="operateChange" v-model="operateCode">
        <a-select-option value="0">批量操作</a-select-option>
        <a-select-option value="1">批量导出</a-select-option>
        <a-select-option value="2">批量禁用</a-select-option>
        <a-select-option value="3">批量启用</a-select-option>
      </a-select>
    </div>
    <a-modal
      :title="title"
      v-model="visible"
      width="600px"
      @cancel="cancel"
      @ok="enSure"
      :centered="true"
      :maskClosable="false"
    >
      <template>
        <div class="user-edit">
          <a-row>
            <a-col :span="6" class="title"> <span style="color: red">*</span>用户帐号： </a-col>
            <a-col :span="14">
              <a-input placeholder="请输入" class="input" v-model="userInfo.userName" v-bind:read-only="isEnable" />
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="6" class="title"> <span style="color: red">*</span>用户姓名： </a-col>
            <a-col :span="14">
              <a-input placeholder="请输入" class="input" v-model="userInfo.name" v-bind:read-only="isEnable" />
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="6" class="title"> <span style="color: red">*</span>用户角色： </a-col>
            <a-col :span="14">
              <a-select
                style="width: 150px"
                :disabled="isEnable"
                v-model="userInfo.roleCode"
                @change="roleChange"
                placeholder="请选择"
              >
                <a-select-option v-for="item in roles" :value="item.roleCode" :key="item.roleCode">{{
                  item.roleName
                }}</a-select-option>
              </a-select>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="6" class="title"> <span style="color: red">*</span>负责版本： </a-col>
            <a-col :span="14">
              <a-select
                style="width: 100%"
                defaultValue="0"
                v-model="selSectionInfos"
                :disabled="isEnable"
                placeholder="请选择"
                mode="multiple"
              >
                <a-select-option v-for="item in sectionInfos" :value="item.dicValue" :key="item.dicValue">{{
                  item.dicValue
                }}</a-select-option>
              </a-select>
            </a-col>
          </a-row>
          <a-row v-if="isShow">
            <a-col :span="6" class="title"> <span style="color: red">*</span>登录密码： </a-col>
            <a-col :span="14">
              <a-input placeholder="请输入" class="input" v-model="userInfo.password" v-bind:read-only="isEnable" />
            </a-col>
          </a-row>
          <a-row v-if="isShow">
            <a-col :span="6" class="title"> <span style="color: red">*</span>确认密码： </a-col>
            <a-col :span="14">
              <a-input placeholder="请输入" class="input" v-model="userInfo.enSurePwd" v-bind:read-only="isEnable" />
            </a-col>
          </a-row>
          <a-row v-if="isEditVisible">
            <a-col :span="6" class="title">默认编辑：</a-col>
            <a-col :span="8" style="margin-top: 5px">
              <a-checkbox :checked="isEdit" @change="editChange" :disabled="isEnable">是</a-checkbox>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="6" class="title">状态：</a-col>
            <a-col :span="8" class="status_col">
              <a-checkbox :checked="isChecked" @change="statusChange" :disabled="isEnable">启用</a-checkbox>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="6" class="title">签名图片：</a-col>
            <a-col :span="8" class="status_col">
              <a-upload
                name="file"
                :fileList="addList"
                :action="uploadAddress"
                :headers="headers"
                @change="uploadAdd"
                :remove="addRemove"
                :data="fileData"
                accept=".jpg, .png"
              >
                <a-button type="primary" style="margin-left: 10px"> 上传图片 </a-button>
              </a-upload>
            </a-col>
          </a-row>
        </div>
      </template>
    </a-modal>

    <a-modal title="查看" v-model="checkVisible" width="600px" :footer="null" :centered="true" :maskClosable="false">
      <template>
        <div class="user-edit">
          <a-row>
            <a-col :span="12" class="title"> 用户帐号： </a-col>
            <a-col :span="12" style="margin-top: 5px">
              {{ userInfo.userName }}
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="12" class="title"> 用户姓名： </a-col>
            <a-col :span="12" style="margin-top: 5px">
              {{ userInfo.name }}
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="12" class="title"> 用户角色： </a-col>
            <a-col :span="12" style="margin-top: 5px">
              {{ userInfo.roleName }}
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="12" class="title"> 负责版本： </a-col>
            <a-col :span="12" style="margin-top: 5px">
              {{ userInfo.sectionInfo }}
            </a-col>
          </a-row>
          <a-row v-if="isShow">
            <a-col :span="12" class="title"> 登录密码： </a-col>
            <a-col :span="12" style="margin-top: 5px">
              {{ userInfo.password }}
            </a-col>
          </a-row>
          <a-row v-if="isShow">
            <a-col :span="12" class="title"> 确认密码： </a-col>
            <a-col :span="12" style="margin-top: 5px">
              {{ userInfo.enSurePwd }}
            </a-col>
          </a-row>
          <a-row v-if="isEditVisible">
            <a-col :span="12" class="title">默认编辑：</a-col>
            <a-col :span="12" style="margin-top: 5px">
              <label v-if="userInfo.isEdit == 1">是</label>
              <label v-if="userInfo.isEdit == 0">否</label>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="12" class="title">状态：</a-col>
            <a-col :span="12" style="margin-top: 5px">
              <label v-if="userInfo.status == 1">启用</label>
              <label v-if="userInfo.status == 0">禁用</label>
            </a-col>
          </a-row>
        </div>
      </template>
    </a-modal>
    <a-modal title="提示" v-model="delVisible" @ok="deleteOk" :centered="true" width="300px" :maskClosable="false">
      <p>确认删除吗？</p>
    </a-modal>
    <a-modal
      title="密码重置"
      v-model="updatePwdVisible"
      @ok="updatePwdOk"
      :centered="true"
      width="300px"
      :maskClosable="false"
    >
      <p>您确定要为该用户进行密码重置？</p>
      <p>重置后密码将被设置为默认密码</p>
    </a-modal>
  </div>
</template>

<script>
const columns = [
  {
    title: "用户帐号",
    dataIndex: "userName",
    width: 150,
  },
  {
    title: "用户姓名",
    dataIndex: "name",
    width: 120,
  },
  {
    title: "用户角色",
    dataIndex: "roleName",
  },
  {
    title: "负责版本",
    dataIndex: "sectionInfo",
  },
  {
    title: "默认编辑",
    width: 120,
    scopedSlots: { customRender: "isEdit" },
  },
  {
    title: "状态",
    width: 120,
    scopedSlots: { customRender: "status" },
  },
  {
    title: "操作",
    width: 320,
    key: "operator",
    scopedSlots: { customRender: "operator" },
  },
];

const data = [];
import qs from "qs";
export default {
  name: "userSet",
  components: {
    // "check-role":checkRole
  },
  data() {
    return {
      serviceAddress: this.$config.serviceAddress,
      uploadAddress: this.$config.serviceAddress + "/file/upload",
      headers: {
        authorization: "authorization-text",
      },
      fileData: {
        fileType: "editors",
      },
      addList: [],
      data,
      columns,
      selectedRowKeys: [],
      visible: false,
      checkVisible: false,
      isEditVisible: false,
      userInfo: {
        userName: "",
        name: "",
        roleCode: "0",
        status: 1,
        password: "",
        enSurePwd: "",
        imgPath: "",
      },
      selSectionInfos: [],
      sectionInfos: [],
      isChecked: true,
      isEdit: false,
      oldUserName: "",
      isEnable: false,
      title: "查看",
      currentMode: "check",
      delVisible: false,
      updatePwdVisible: false,
      updatePwdUserName: "",
      queryUserName: "",
      queryName: "",
      queryRoleCode: "0",
      roles: [],
      sort: "1",
      sortField: "user_code",
      sortType: "desc",
      userType: 2,
      operateCode: "0",
      isShow: true,
      page: 1,
      limit: 20,
      total: 0,
      pageSizeOptions: ["10", "20", "30", "40", "50"],
      table_height: 0,
    };
  },
  computed: {
    rowSelection() {
      const { selectedRowKeys } = this;
      return {
        columnWidth: 35,
        selectedRowKeys,
        onChange: this.onSelectChange,
        hideDefaultSelections: true,
        onSelection: this.onSelection,
      };
    },
  },
  created() {
    this.query();

    this.axios
      .get("/systemUser/queryAllRole", {
        params: {
          time: new Date().getTime(),
        },
        paramsSerializer: function (p) {
          return qs.stringify(p, { arrayFormat: "repeat" });
        },
      })
      .then(res => {
        this.roles = res.data;
      });
    this.axios.get("/dataDic/queryChild", { params: { parentCode: "section_info" } }).then(res => {
      if (res.data) {
        this.sectionInfos = res.data;
      } else {
        this.utils.messageInfo(this, "error", "查询刊物版本失败！");
      }
    });
  },
  mounted() {
    //设置bottom高度
    var height = document.body.clientHeight;
    var bottom_height = height - 230;
    var bottom = document.getElementById("bottom");
    bottom.style.height = bottom_height + "px";
    this.table_height = bottom_height - 100;
  },
  methods: {
    onShowSizeChange(current, pageSize) {
      this.page = current;
      this.limit = pageSize;
      this.query();
    },
    pageChange(pageNumber) {
      this.page = pageNumber;
      this.query();
    },
    roleChange() {
      var roleName = "";
      for (var i = 0; i < this.roles.length; i++) {
        if (this.roles[i].roleCode == this.userInfo.roleCode) {
          roleName = this.roles[i].roleName;
        }
      }
      if (roleName.indexOf("责编") != -1) {
        this.isEditVisible = true;
      } else {
        this.isEditVisible = false;
      }
    },
    sortChange() {
      if (this.sort == 1) {
        this.sortField = "user_code";
        this.sortType = "desc";
      } else if (this.sort == 2) {
        this.sortField = "user_code";
        this.sortType = "";
      } else if (this.sort == 3) {
        this.sortField = "create_time";
        this.sortType = "desc";
      } else if (this.sort == 4) {
        this.sortField = "create_time";
        this.sortType = "";
      }
      this.query();
    },
    operateChange() {
      var itemLegth = this.selectedRowKeys.length;
      if (itemLegth == 0) {
        this.utils.messageInfo(this, "error", "最少选择一条数据！");
        return;
      }
      if (this.operateCode == 1) {
        if (this.serviceAddress == "") {
          this.utils.messageInfo(this, "error", "获取后台ip地址失败，无法导出！");
          return;
        }
        var selectedRowKeys = this.selectedRowKeys;
        window.open(this.serviceAddress + "/systemUser/exportData?codeArr=" + selectedRowKeys + "");
      } else if (this.operateCode == 2) {
        this.batchChangeStatus(0);
      } else if (this.operateCode == 3) {
        this.batchChangeStatus(1);
      }
    },
    batchChangeStatus(status) {
      this.axios
        .post("/systemUser/changeUserStatus", {
          status: status,
          codes: JSON.stringify(this.selectedRowKeys),
        })
        .then(res => {
          if (res.data.code == "OK") {
            if (status == "0") {
              this.utils.messageInfo(this, "success", "禁用成功！");
            } else {
              this.utils.messageInfo(this, "success", "启用成功！");
            }
            this.query();
          } else {
            this.utils.messageInfo(this, "error", "操作失败！");
          }
        });
    },
    statusChange(e) {
      if (e.target.checked) {
        this.isChecked = true;
        this.userInfo.status = 1;
      } else {
        this.isChecked = false;
        this.userInfo.status = 0;
      }
    },
    editChange(e) {
      if (e.target.checked) {
        this.isEdit = true;
        this.userInfo.isEdit = 1;
      } else {
        this.isEdit = false;
        this.userInfo.isEdit = 0;
      }
    },
    query() {
      this.axios
        .get("/systemUser/querySystemUser", {
          params: {
            userName: this.queryUserName,
            name: this.queryName,
            roleCode: this.queryRoleCode,
            sortField: this.sortField,
            sortType: this.sortType,
            userType: this.userType,
            page: this.page,
            limit: this.limit,
            time: new Date().getTime(),
          },
          paramsSerializer: function (p) {
            return qs.stringify(p, { arrayFormat: "repeat" });
          },
        })
        .then(res => {
          if (res.data.code == "0") {
            this.total = res.data.count;
            this.data = res.data.data;
          } else {
            this.utils.messageInfo(this, "error", "查询用户列表失败！");
          }
        });
    },
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys;
    },
    addMethod(type) {
      this.userInfo = {
        userName: "",
        name: "",
        roleCode: "",
        status: 1,
        password: "",
        enSurePwd: "",
        imgPath: "",
      };
      this.addList = [];
      this.isEnable = false;
      this.visible = true;
      this.isShow = true;
      this.title = "新增";
      this.currentMode = type;
    },
    checkMethod(obj) {
      this.userInfo = obj;
      this.checkVisible = true;
      this.isShow = false;
    },
    editMethod(obj, type) {
      if (obj.isEdit == 1) {
        this.isEdit = true;
      } else {
        this.isEdit = false;
      }
      if (obj.status == 1) {
        this.isChecked = true;
      } else {
        this.isChecked = false;
      }
      this.userInfo = {
        userCode: obj.userCode,
        userName: obj.userName,
        name: obj.name,
        roleCode: obj.roleCode,
        imgPath: obj.imgPath,
      };
      if (obj.imgPath) {
        this.addList = [
          {
            uid: "1",
            name: "sign.png",
            status: "done",
            url: this.serviceAddress + obj.imgPath,
          },
        ];
      }
      if (obj.sectionInfo) {
        this.selSectionInfos = obj.sectionInfo.split(",");
      }
      this.roleChange();
      this.userInfo.oldRoleCode = obj.roleCode;
      this.oldUserName = obj.userName;
      this.isEnable = false;
      this.visible = true;
      this.isShow = false;
      this.title = "编辑";
      this.currentMode = type;
    },
    changeStatus(obj, status) {
      var codes = [];
      codes.push(obj.userCode);
      this.axios
        .post("/systemUser/changeUserStatus", {
          codes: JSON.stringify(codes),
          status: status,
        })
        .then(res => {
          if (res.data.code == "OK") {
            if (status == "0") {
              this.utils.messageInfo(this, "success", "禁用成功！");
            } else {
              this.utils.messageInfo(this, "success", "启用成功！");
            }
            for (var i = 0; i < this.data.length; i++) {
              if (this.data[i].userCode == obj.userCode) {
                this.data[i].status = status;
              }
            }
          } else {
            this.utils.messageInfo(this, "error", "编辑失败！");
          }
        });
    },
    deleteMethod(record) {
      this.delVisible = true;
      this.userInfo = record;
    },
    deleteOk() {
      this.axios
        .post("/systemUser/deleteSystemUser", {
          userCode: this.userInfo.userCode,
        })
        .then(res => {
          if (res.data.code == "OK") {
            this.utils.messageInfo(this, "success", "删除成功");
            this.delVisible = false;
            this.query();
          } else {
            this.utils.messageInfo(this, "error", "删除失败！");
          }
        });
    },
    cancel() {
      this.visible = false;
    },
    enSure() {
      if (this.currentMode == "check") {
        this.visible = false;
      } else if (this.currentMode == "edit") {
        if (this.userInfo.userName == "") {
          this.utils.messageInfo(this, "error", "用户帐号不能为空！");
          return;
        } else if (this.userInfo.name == "") {
          this.utils.messageInfo(this, "error", "用户姓名不能为空！");
          return;
        } else if (this.userInfo.roleCode == "0" || this.userInfo.roleCode == "") {
          this.utils.messageInfo(this, "error", "请选择用户角色！");
          return;
        }
        this.axios
          .post("/systemUser/updateSystemUser", {
            userCode: this.userInfo.userCode,
            userName: this.userInfo.userName,
            isEdit: this.userInfo.isEdit,
            status: this.userInfo.status,
            name: this.userInfo.name,
            roleCode: this.userInfo.roleCode,
            oldUserName: this.oldUserName,
            oldRoleCode: this.userInfo.oldRoleCode,
            imgPath: this.userInfo.imgPath,
            sectionInfo: this.selSectionInfos.join(),
          })
          .then(res => {
            if (res.data.code == "OK") {
              this.utils.messageInfo(this, "success", "编辑成功");
              this.query();
              this.visible = false;
            } else {
              this.utils.messageInfo(this, "error", res.data.data);
            }
          });
      } else if (this.currentMode == "add") {
        if (this.userInfo.userName == "") {
          this.utils.messageInfo(this, "error", "用户帐号不能为空！");
          return;
        } else if (this.userInfo.name == "") {
          this.utils.messageInfo(this, "error", "用户姓名不能为空！");
          return;
        } else if (this.userInfo.roleCode == "0") {
          this.utils.messageInfo(this, "error", "请选择用户角色！");
          return;
        } else if (!this.utils.checkPwd(this.userInfo.password)) {
          this.$message.error("密码必须是8至16位，包含大小写字母、数字和特殊字符");
          return;
        } else if (this.userInfo.password != this.userInfo.enSurePwd) {
          this.utils.messageInfo(this, "error", "两次密码输入不一致！");
          return;
        }
        this.axios
          .post("/systemUser/saveSystemUser", {
            userName: this.userInfo.userName,
            password: this.userInfo.password,
            isEdit: this.userInfo.isEdit,
            status: this.userInfo.status,
            userType: this.userType,
            name: this.userInfo.name,
            roleCode: this.userInfo.roleCode,
            imgPath: this.userInfo.imgPath,
            sectionInfo: this.selSectionInfos.join(),
          })
          .then(res => {
            if (res.data.code == "OK") {
              this.utils.messageInfo(this, "success", "添加成功");
              this.query();
              this.visible = false;
            } else {
              this.utils.messageInfo(this, "error", res.data.data);
            }
          });
      }
    },
    updatePwd(data) {
      this.updatePwdUserName = data.userName;
      this.updatePwdVisible = true;
    },
    updatePwdOk() {
      this.axios
        .post("/systemUser/updateDefaultPwd", {
          userName: this.updatePwdUserName,
          newPwd: "Bianji@123456",
        })
        .then(res => {
          if (res.data.code == "OK") {
            this.utils.messageInfo(this, "success", "重置密码成功！");
            this.query();
          } else {
            this.utils.messageInfo(this, "error", res.data.data);
          }
        });
      this.updatePwdVisible = false;
    },
    uploadAdd(info) {
      this.addList = [info.file];
      if (info.file.status === "done") {
        this.addList[0].url = info.file.response.data.filePath;
        this.userInfo.imgPath = this.addList[0].url;
        this.utils.messageInfo(this, "success", "上传成功");
      } else if (info.file.status === "error") {
        this.utils.messageInfo(this, "error", "上传失败");
      }
    },
    addRemove(file) {
      this.addList = [];
      var data = file.response;
      if (data.code == "OK") {
        this.axios.post("/file/deleteFile", {
          url: data.data.realFilePath,
        });
        this.userInfo.imgPath = "";
      }
    },
  },
};
</script>
<style>
@import "../../../../assets/css/PageCss.css";
</style>
<style scoped>
.user-edit .ant-row {
  margin-bottom: 10px;
}
.user-edit .title {
  text-align: right;
  line-height: 32px;
}
.status_col {
  margin-top: 5px;
}
.status_img {
  width: 18px;
  margin-right: 6px;
  margin-bottom: 3px;
}
</style>
